export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/gukhwa-jang-794760a1f3806ab2bb8dd9f9b04aafb0.jpg";